import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { uploadSingle, uploadMultiple, deleteUpload } from "../api/uploads";
export default function UploadsPage() {
    const [uploads, setUploads] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState("");
    const handleUpload = async (e, multi) => {
        const files = e.target.files;
        if (!files || files.length === 0)
            return;
        setUploading(true);
        setError("");
        try {
            if (multi) {
                const res = await uploadMultiple(Array.from(files));
                setUploads((prev) => [...prev, ...res.files]);
            }
            else {
                const res = await uploadSingle(files[0]);
                setUploads((prev) => [...prev, res]);
            }
        }
        catch (err) {
            setError(err?.response?.data?.error || "Yükleme başarısız");
        }
        finally {
            setUploading(false);
            e.target.value = "";
        }
    };
    const handleDelete = async (filename) => {
        try {
            await deleteUpload(filename);
            setUploads((prev) => prev.filter((u) => u.filename !== filename));
        }
        catch {
            alert("Silme başarısız");
        }
    };
    const copyUrl = (url) => {
        navigator.clipboard.writeText(url).then(() => alert("URL kopyalandı!"));
    };
    return (_jsxs("div", { children: [_jsx("div", { className: "page-header", children: _jsx("h2", { className: "page-title", children: "Medya Y\u00FCkleme" }) }), error && _jsx("div", { className: "alert alert-error", children: error }), _jsxs("div", { className: "card mb-4", children: [_jsx("h3", { className: "card-title", children: "Dosya Y\u00FCkle" }), _jsx("p", { className: "text-muted mb-2", children: "Desteklenen formatlar: JPG, PNG, WebP, GIF, AVIF, SVG (Max 10MB)" }), _jsxs("div", { className: "form-row", children: [_jsxs("label", { className: "btn btn-secondary", style: { cursor: "pointer" }, children: ["Tek Dosya Se\u00E7", _jsx("input", { type: "file", accept: "image/*", onChange: (e) => handleUpload(e, false), hidden: true })] }), _jsxs("label", { className: "btn btn-secondary", style: { cursor: "pointer" }, children: ["\u00C7oklu Dosya Se\u00E7 (Max 30)", _jsx("input", { type: "file", accept: "image/*", multiple: true, onChange: (e) => handleUpload(e, true), hidden: true })] }), uploading && _jsx("span", { className: "text-muted", children: "Y\u00FCkleniyor..." })] })] }), _jsx("div", { className: "image-grid", children: uploads.map((u, i) => (_jsxs("div", { className: "image-thumb", children: [_jsx("img", { src: u.url, alt: u.filename }), _jsxs("div", { className: "image-info", children: [_jsx("span", { className: "mono text-sm", children: u.filename }), _jsxs("span", { className: "text-muted text-sm", children: [(u.size / 1024).toFixed(1), " KB"] })] }), _jsxs("div", { className: "image-actions", children: [_jsx("button", { onClick: () => copyUrl(u.url), className: "btn-sm btn-secondary", children: "URL Kopyala" }), _jsx("button", { onClick: () => handleDelete(u.filename), className: "btn-sm btn-danger", children: "Sil" })] })] }, i))) }), uploads.length === 0 && !uploading && (_jsx("p", { className: "empty-text", children: "Hen\u00FCz dosya y\u00FCklenmedi. Yukar\u0131dan dosya se\u00E7erek y\u00FCkleyebilirsiniz." }))] }));
}
